import { Bundle } from '@spiffcommerce/core'
import { formatCentsToDollars } from '../../../helpers/formatCentsToDollars'
import { useShopifyMetadata } from '../../../hooks/useShopifyMetadata'
import { CustomScene } from '../../../types/types'
import { HandleDrawer } from '../../HandleDrawer/HandleDrawer'
import { Summary } from '../Summary/Summary'

export const SummaryScene = ({
  bundle,
  allScenes,
  addedToCart,
  handleAddToCart,
  setCurrentScene,
  setShowSummaryScene
}: {
  bundle: Bundle
  allScenes: CustomScene[]
  addedToCart: boolean
  handleAddToCart: () => Promise<void>
  setCurrentScene: React.Dispatch<React.SetStateAction<number>>
  setShowSummaryScene: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const shopifyMetadata = useShopifyMetadata()
  const numberOfPendantScenes = allScenes.filter((scene) => scene?.isPendantScene).length

  return (
    <div className="flex flex-col items-center justify-between">
      <Summary
        isSceneMenu={false}
        allScenes={allScenes}
        numberOfPendantScenes={numberOfPendantScenes}
        onClick={(i) => {
          if (addedToCart) return
          setCurrentScene(i)
          setShowSummaryScene(false)
        }}
      />
      <div className="px-5 pt-6 w-full flex flex-col gap-4">
        <button
          disabled={addedToCart}
          onClick={handleAddToCart}
          className="Button min-h-[35px] lg:min-h-[44px] bg-ink text-white border border-solid border-deep-grey rounded-[2px] py-2 px-3 lg:py-3 mb-7 lg:mt-2.5 lg:mb-9 w-full flex justify-center uppercase disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span>Add to Bag</span>
        </button>

        <div className="px-0 mb-2.5 uppercase">
          <span>
            Buy now or pay later.{' '}
            <HandleDrawer drawerId="necklace-builder-bnpl-drawer" className="Link--underline">
              {shopifyMetadata?.modals.bnpl.label || 'See options'}
            </HandleDrawer>
          </span>
        </div>

        {/* <button className="text-[#2D2B2C] p-4 w-full flex justify-between items-center uppercase border border-[#2D2B2C]">
          <span>Generate High Quality Preview</span>
          <LetterIcon />
        </button> */}
      </div>
    </div>
  )
}
